<template>
  <v-container fluid py-2>
    <!-- Resume cards -->
    <v-layout row wrap justify-center>
      <!-- Total items. Temporarily removed.  -->
      <!-- <v-flex sm4 xs12 md3 lg2 pr-2 py-2>
        <v-card color="tertiary" class="white--text text-xs-center">
          <v-chip color="tertiary" text-color="white">
            <v-avatar>
              <v-icon>mdi-buffer</v-icon>
            </v-avatar>
            {{ total_items }}
          </v-chip>
        </v-card>
      </v-flex> -->
      <v-flex sm4 xs12 md3 lg2 pr-2 py-2>
        <v-card color="deep-orange darken-1" class="white--text text-xs-center">
          <v-chip color="deep-orange darken-1" text-color="white">
            <v-avatar>
              <v-icon>mdi-coin</v-icon>
            </v-avatar>
            {{ total_hold|currency }}
            pending
          </v-chip>
        </v-card>
      </v-flex>
      <v-flex sm4 xs12 md3 lg2 pr-2 py-2>
        <v-card color="blue darken-1" class="white--text text-xs-center">
          <v-chip color="blue darken-1" text-color="white">
            <v-avatar>
              <v-icon>mdi-coin</v-icon>
            </v-avatar>
            {{ total_approved|currency }}
            approved
          </v-chip>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CoreHelper from '@/helper/CoreHelper'
import { mapState } from 'vuex'

export default {
  filters: {
    currency: function (val) {
      return CoreHelper.toCurrency(val)
    }
  },
  computed: mapState({
    total_items: state => state.resume.totalItems,
    total_hold: state => state.resume.totalHold,
    total_approved: state => state.resume.totalApproved
  })
}
</script>
